import React from 'react';
import { useSearchParams } from 'react-router-dom';
import PageMeta from './PageMeta';
import { useTranslation } from '../contexts/LanguageContext';
import './LegalDocument.css';

const SUPPORT_EMAIL = 'support@word-labyrinth.com';
const MailLink = ({ children }) => <a href={`mailto:${SUPPORT_EMAIL}`}>{children}</a>;

function DeletionStatus() {
    const { t } = useTranslation();
    const [searchParams] = useSearchParams();
    const code = searchParams.get('code') || t('settings.deletionStatus.notAvailable');

    return (
        <div className="legal-document">
            <PageMeta path="/deletion-status" />
            <div className="legal-container">
                <h1>{t('settings.deletionStatus.heading')}</h1>

                <section>
                    <p>{t('settings.deletionStatus.processed')}</p>

                    <p>{t.rich('settings.deletionStatus.confirmationCode', { b: <strong /> }, { code })}</p>

                    <p>{t('settings.deletionStatus.unlinked')}</p>

                    <p>
                        {t.rich('settings.deletionStatus.fullDelete', { mail: <MailLink /> }, { email: SUPPORT_EMAIL })}
                    </p>
                </section>
            </div>
        </div>
    );
}

export default DeletionStatus;
